import axios from 'api/axios-configure'
import { Grid } from "@mui/material"
import { Tooltip } from "monday-ui-react-core"
import { useEffect, useMemo, useState } from "react"
import { UITableReport } from 'components/UITableReport'
import { List } from 'react-bootstrap-icons'

const OrganizationSenderDetail = ({changedOrg, setDisplayReceiverDetail, setViewReceiverInformation}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)

    const [tableData, setTableData] = useState([])

    const columns = useMemo(() => 
    [
        {
            size: 200,
            maxSize: 200,
            accessorKey: 'senderName',
            header: 'Sender Name'
        },
        {
            size: 200,
            maxSize: 200,
            accessorKey: 'senderNumber',
            header: 'Sender Number'
        },
        {
            size: 25,
            maxSize: 25,
            accessorKey: 'documentType',
            header: 'Document Type'
        },
        {
            header: 'Actions',
            size: 60,
            enableSorting: false,
            maxSize: 60,
            accesorKey: 'actions',
            Cell: ({row}) => {
                return (
                    <div className='d-flex align-items-center'>
                        <Tooltip content="View Receivers">
                            <List 
                                className='payout-icon'
                                size={15}
                                onClick={() => handleViewReceiversOpen(row.original)}
                            />
                        </Tooltip>
                    </div>
                )
            }
        }
    ])

    const handleViewReceiversOpen = (row) => {
        setViewReceiverInformation({
            senderName: row.senderName,
            senderNumber: row.senderNumber,
            documentType: row.documentType
        })

        setDisplayReceiverDetail(true)
    }

    const loadPage = () => {
        if (!tableData.length) {
            setIsLoading(true)
        } else {
            setIsFetching(true)
        }

        axios.get('/GetOrganizationSenderDetails')
            .then(response => {
                setTableData(response.data)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setIsLoading(false)
                setIsFetching(false)
            })
    }

    useEffect(() => {
        loadPage()
    }, [])

    useEffect(() => {
        if (changedOrg) {
            loadPage()
        }
    }, [changedOrg])


    return (
        <>
            <Grid item xs={12} lg={10}>
                <h4>Sender Details</h4>
            </Grid>
            <Grid item xs={12} lg={12} mt={2}>
                <UITableReport
                    columns={columns}
                    data={tableData}
                    isLoading={isLoading}
                    isFetching={isFetching}
                />
            </Grid>
        </>
    );
}

export default OrganizationSenderDetail